import { useEffect } from "react";
import { setUser } from "@sentry/nextjs";

/**
 * Used for Sentry to identify unique users
 */
export function SentryUserManager({ email, orderId }) {
    useEffect(() => {
        const ip_address = "{{auto}}";
        setUser({
            email: email,
            username: orderId,
            ip_address: ip_address,
        });
    }, [email, orderId]);
    return null;
}
